import React, { useCallback, useEffect , useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { getDashboardCount } from "../redux/actions/DashboardActions";
import styled from "styled-components";
import { Row, Col, Card, Table, Pagination, Button, Badge, Form } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import { deleteCityData, getCityList, updateCityStatusData } from "../../redux/actions/CityActions";
import RoundedPagination from "../../Components/Paginate";
import { Link, useNavigate } from "react-router-dom";
import swal from 'sweetalert2';
import { toast } from "react-toastify";
import { logout } from "../../redux/actions/AuthActions";
import useDebounce from "../../hooks/useDebounce";
import Preloader from "../../Components/Preloader";
import { getAttendanceMonthlyList } from "../../redux/actions/AttendanceActions";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { CSVLink } from 'react-csv';
import { apiURL } from "../../axios";


const MonthlyAttendance = () => {
  const { t } = useTranslation();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const navigate=useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [editCityId, setEditCityId] = useState(null);
  const {
    AuthReducer: { auth,errors,loading },
    attendanceReducers: {
      monthlyAttendancePermissions,
      monthlyAttendanceLists,
      loadingAttendance,
      errorsAttendance,
      monthlyAttendanceCount,
    },
  } = useSelector((city) => city);
  const [page, setPage] = useState(1);
  const [paginate, setPaginate] = useState(10);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState('desc');
  const [month, setMonth] = useState(new Date());
  const indexOfLastItem = (page + 1) * paginate;
  const indexOfFirstItem = indexOfLastItem - paginate;
  
  
  const fetchCityList = useCallback(() => {
    if (auth?.token) {
      dispatch(getAttendanceMonthlyList(auth.token, paginate, page, search, sort,month));
    }
  }, [auth, paginate, page, search, sort, dispatch]);

  useDebounce(fetchCityList, 500, [auth, paginate, page, search, sort]);

  const csvHead = [['SR No.', 'Name', 'Contact Number', 'User Type',
    'Total Days', 'Total Working', 'Total Week Off', 'Total Half Days', 'Total Leave',
    'Total W.F.H', 'Total Sunday Working', 'Total Absent']
  ]
  const csvData = monthlyAttendanceLists.map((cv, index) => {
    const totalMonth=new Date(month.getFullYear(), parseInt(month.getMonth()) + 1, 0).getDate();
    return [
      index + 1,
      cv?.name,
      cv?.phone || '',
      cv?.user_type || '',
      totalMonth || '0',
      cv?.Total_working_days || '0',
      cv?.Total_weak_off_days || '0',
      cv?.Total_half_days || '0',
      cv?.Total_leave_days || '0',
      cv?.Total_wfh_days || '0',
      cv?.Total_sunday_working_days || '0',
      cv?.Total_absent_days || '0',
    ];
  });
  const exportData = csvHead.concat(csvData);

  useEffect(() => {
    if(errors)
    {
      if(errors?.status==401)
      {
        dispatch(logout())
        toast.error(errors?.data?.message);
        navigate('/login');
        window.location.reload();
      }
    }
  },[errors])

  const inputDateHandler = (value) => {
    //const { value, name } = e.target;
    //setFormData({ ...formData, [name]: value });
    setMonth(value);
    dispatch(getAttendanceMonthlyList(auth.token, paginate, page, search, sort,value));
  };

  const handlePaginateChange = (e) => {
    const value = e.target.value === "All" ? monthlyAttendanceCount : parseInt(e.target.value);
    setPaginate(value);
    setPage(1); // Reset to the first page whenever the paginate value changes
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  useEffect(() => {
    document.title = `Monthly Attendance :: ${auth?.generalSettings?.title}`;
  }, []);


  const printTable = () => {
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write(`<html><head><style type="text/css">'+
      '#backgroundImage{'+
        'min-height: 50vh;'+
        'position: relative;'+
        'margin: 0;'+
        '-webkit-print-color-adjust: exact !important; '+
        'color-adjust: exact !important;'+
        '}'+
        '#backgroundImage:before {'+
        'content: "";'+
        'position: absolute;'+
        'z-index: -1;'+
        'top: 0;'+
        'bottom: 0;'+
        'left: 0;'+
        'right: 0;'+
        'opacity: 0.04;'+
        'background:'+
            'url(\'${apiURL}logo.jpg\')'+
        '}'+
        '</style></head><body onload="window.print()" id="backgroundImage"><div align="center ">'+document.title+'</div><div class="main1"><table border="1" cellspacing="0">`);
    printWindow.document.write(document.getElementById('table-to-print').innerHTML);
    printWindow.document.write('</table></div><div align="center">This is a system generated report it does not require any signature or stamp</div><div align="right"><img src="logo.jpg" style="opacity: 0.1"></div></body></html>');
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };


  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Attendance Report"), path: "/Attendance/Monthly", active: false },
          { label: t("Monthly Attendance"), path: "/Attendance/Monthly", active: true },
        ]}
        title={t("Monthly Attendance")}
      />

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div className="mb-2">
                <Row>
                {(monthlyAttendancePermissions.filter ) && (<>
                    <Col lg={3}>
                    <Form.Group className="mb-3">
                      <DatePicker
                        selected={month}
                        onChange={(value) => inputDateHandler(value)}
                        dateFormat="yyyy-MM" // Display the date in yyyy-MM-dd format
                        maxDate={(() => {
                          const date = new Date();
                          //date.setFullYear(date.getFullYear() - 0);  // Subtract 18 years
                          return date;
                        })()}
                        className="form-control"
                        withPortal
                        showYearDropdown
                        scrollableYearDropdown
                        showMonthYearPicker
                        isClearable
                      />
                    </Form.Group>
                  </Col>
                  </>)}
                  <Col lg={3}>
                    <div className="d-flex align-items-center">
                    {(monthlyAttendancePermissions.filter ) && (<>
                      <input
                        type="search"
                        placeholder="Search..."
                        className="form-control ms-1"
                        autoComplete="off"
                        value={search}
                        onChange={handleSearchChange}
                      />
                      
                    </>)}
                      
                    </div>
                  </Col>
                  
                  
                  
                  <Col lg={6}>
                    <div className="d-flex justify-content-end align-items-center">
                      <div className="button-list">
                      {(monthlyAttendancePermissions.print ) && (<>
                        <Button variant="dark" onClick={printTable}>
                          <i className="mdi mdi-printer me-1"></i>Print
                        </Button>
                      </>)}
                      {(monthlyAttendancePermissions.excel ) && (<>
                        <CSVLink
                          filename="monthly-attendance-reports.csv"
                          data={exportData}
                          className="btn btn-info text-white ms-1"
                          title="Export To CSV"
                        >
                          <i className="mdi mdi-file-excel me-1"></i>
                          Excel
                        </CSVLink>
                      </>)}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              <div style={{overflowY:'auto',maxHeight:'500px',border: "1px solid #dee2e6"}}>
                <Table className="mb-0 table-bordered"
                  id="table-to-print"
                  size="sm"
                  striped
                  responsive
                  >
                  <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1 }}>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Phone</th>
                      <th>User Type</th>
                      <th>Total Days</th>
                      <th>Total Working</th>
                      <th>Total Week Off</th>
                      <th>Total Half Days</th>
                      <th>Total Leave</th>
                      <th>Total W.F.H.</th>
                      <th>Total Sunday Working</th>
                      <th>Total Absent</th>
                    </tr>
                  </thead>
                  <tbody>
                  {monthlyAttendanceLists.length === 0 ? (
                    <tr>
                      <td colSpan="12">No data found</td>
                    </tr>
                  ) : (<>
                    {monthlyAttendanceLists?.map?.((item, index) => {
                      const totalMonth=new Date(month.getFullYear(), parseInt(month.getMonth()) + 1, 0).getDate();
                      return (
                        <tr key={item.id}>
                          <th scope="row">
                          {index + 1 + (page - 1) * paginate}
                          </th>
                          <td>
                          <Link to={`/Attendance/Monthly-Details/${item?.id}/${month}`} className="action-icon text-dark"> 
                          {item?.name}
                          </Link>
                          </td>
                          <td>{item?.phone}</td>
                          <td>{item?.user_type}</td>
                          <td>{totalMonth}</td>
                          <td>{item?.Total_working_days}</td>
                          <td>{item?.Total_weak_off_days}</td>
                          <td>{item?.Total_half_days}</td>
                          <td>{item?.Total_leave_days}</td>
                          <td>{item?.Total_wfh_days}</td>
                          <td>{item?.Total_sunday_working_days}</td>
                          <td>{item?.Total_absent_days}</td>
                        </tr>
                      );
                    })}</>
                  )}
                  </tbody>
                </Table>
              </div>
              <div class="mt-3 d-lg-flex align-items-center text-center pb-1">
                <div class="d-inline-block me-3">
                  <label class="me-1">Display :</label>
                  <select class="form-select d-inline-block w-auto" onChange={handlePaginateChange}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
                <span class="me-3">Page <strong>{page}</strong> of <strong>{Math.ceil(monthlyAttendanceCount / paginate)}</strong> </span>
                <RoundedPagination currentPage={page} totalPages={Math.ceil(monthlyAttendanceCount / paginate)} onPageChange={(pageNumber) => setPage(pageNumber)}/>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      
      
      {loadingAttendance && (<Preloader/>)}
    </>
  );
};

export default MonthlyAttendance;
